module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523536162.gif?imageView2/1/w/100/h/100",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("番剧")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "play-nav"
  }, [_c('li', [_vm._v("新番连载")]), _vm._v(" "), _c('li', [_vm._v("旧番补档")]), _vm._v(" "), _c('li', [_vm._v("过场动画")]), _vm._v(" "), _c('li', [_vm._v("动画资讯")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523569142.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("动画")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "animate-nav"
  }, [_c('li', [_vm._v("MAD·AMV")]), _vm._v(" "), _c('li', [_vm._v("MMD·3D")]), _vm._v(" "), _c('li', [_vm._v("2.5次元")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523474487.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("娱乐")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "disport-nav"
  }, [_c('li', [_vm._v("生活娱乐")]), _vm._v(" "), _c('li', [_vm._v("鬼畜调教")]), _vm._v(" "), _c('li', [_vm._v("萌宠")]), _vm._v(" "), _c('li', [_vm._v("美食")]), _vm._v(" "), _c('li', [_vm._v("综艺")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523552005.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("游戏")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "game-nav"
  }, [_c('li', [_vm._v("游戏集锦")]), _vm._v(" "), _c('li', [_vm._v("电子竞技")]), _vm._v(" "), _c('li', [_vm._v("主机单机")]), _vm._v(" "), _c('li', [_vm._v("英雄联盟")]), _vm._v(" "), _c('li', [_vm._v("守望先锋")]), _vm._v(" "), _c('li', [_vm._v("桌游卡牌")]), _vm._v(" "), _c('li', [_vm._v("Mugen")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523586727.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("音乐")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "music-nav"
  }, [_c('li', [_vm._v("原创·翻唱")]), _vm._v(" "), _c('li', [_vm._v("演奏")]), _vm._v(" "), _c('li', [_vm._v("Vocaloid")]), _vm._v(" "), _c('li', [_vm._v("日系音乐")]), _vm._v(" "), _c('li', [_vm._v("综合音乐")]), _vm._v(" "), _c('li', [_vm._v("演唱会")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523606418.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("舞蹈")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dance-nav"
  }, [_c('li', [_vm._v("宅舞")]), _vm._v(" "), _c('li', [_vm._v("综合舞蹈")]), _vm._v(" "), _c('li', [_vm._v("爱豆")]), _vm._v(" "), _c('li', [_vm._v("手作")]), _vm._v(" "), _c('li', [_vm._v("造型")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523679990.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("科技")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "science-nav"
  }, [_c('li', [_vm._v("科学技术")]), _vm._v(" "), _c('li', [_vm._v("教程")]), _vm._v(" "), _c('li', [_vm._v("数码")]), _vm._v(" "), _c('li', [_vm._v("汽车")]), _vm._v(" "), _c('li', [_vm._v("广告")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523695622.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("体育")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "sport-nav"
  }, [_c('li', [_vm._v("综合体育")]), _vm._v(" "), _c('li', [_vm._v("足球")]), _vm._v(" "), _c('li', [_vm._v("篮球")]), _vm._v(" "), _c('li', [_vm._v("搏击")]), _vm._v(" "), _c('li', [_vm._v("11区体育")]), _vm._v(" "), _c('li', [_vm._v("惊奇体育")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_03/1488523660989.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("鱼塘")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "pound-nav"
  }, [_c('li', [_vm._v("历史")])])]), _vm._v(" "), _c('div', {
    staticClass: "channel-nav"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_10/1489114940717.gif?imageView2/1/w/100/h/100",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("文章")]), _vm._v(" "), _c('span', [_vm._v("更多"), _c('i', {
    staticClass: "fa fa-angle-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "article-nav"
  }, [_c('li', [_vm._v("工作情感")]), _vm._v(" "), _c('li', [_vm._v("动漫文化")]), _vm._v(" "), _c('li', [_vm._v("漫画小说")]), _vm._v(" "), _c('li', [_vm._v("综合")]), _vm._v(" "), _c('li', [_vm._v("游戏")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f60f0bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/channel.vue
// module id = 108
// module chunks = 0